import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  menu: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the menu
export const fetchMenu = createAsyncThunk(
  "fetchMenu/menu",
  async ({ enqueueSnackbar, limit = 10, page = 0, category_id }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`menu`, {
        params: {
          page: page + 1,
          limit,
          category_id,
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create menu
export const createMenu = createAsyncThunk(
  "createMenu/menu",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`menu`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update menu
export const updateMenu = createAsyncThunk(
  "updateMenu/menu",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`menu/${id}`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete menu
export const deleteEventImage = createAsyncThunk(
  "deleteEventImage/menu",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`menu/media/${id}`, data);
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete menu
export const deleteMenu = createAsyncThunk(
  "deleteMenu/menu",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`menu/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete menuImage
export const deleteMenuImage = createAsyncThunk(
  "deleteMenuImage/menuImage",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`menu/media/${id}`, data);
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const menulice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    resetMenu: (state) => {
      state.fetchLoading = false;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: create menu
    builder.addCase(fetchMenu.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchMenu.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.menu = action.payload;
    });

    builder.addCase(fetchMenu.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create menu
    builder.addCase(createMenu.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createMenu.fulfilled, (state, action) => {
      state.isLoading = false;
      state.menu.data = [action.payload.data, ...state.menu.data];
      state.menu.meta.total = state.menu.meta.total + 1;
      action.payload.enqueueSnackbar("Menu is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createMenu.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update menu
    builder.addCase(updateMenu.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateMenu.fulfilled, (state, action) => {
      state.isLoading = false;
      state.menu.data = state.menu.data.map((menu) => {
        if (menu.slug === action.payload.data.slug) {
          return action.payload.data;
        } else {
          return menu;
        }
      });
      action.payload.enqueueSnackbar("Menu is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateMenu.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete menu
    builder.addCase(deleteMenu.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteMenu.fulfilled, (state, action) => {
      state.isLoading = false;
      state.menu.data = state.menu.data.filter(
        (menu) => menu.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("Menu is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteMenu.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete media
    builder.addCase(deleteMenuImage.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteMenuImage.fulfilled, (state, action) => {
      state.isLoading = false;
      state.menu.data = state.menu.data.filter(
        (media) => media.id !== action.payload?.data
      );
      // action.payload.enqueueSnackbar &&
      //   action.payload.enqueueSnackbar("Media is deleted successfully.", {
      //     variant: "success",
      //   });
      // action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteMenuImage.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default menulice.reducer;

export const { resetMenu } = menulice.actions;
